const YouTubeStructuredData = ({
    id,
    title = 'YouTube Video',
    description = 'A video from YouTube',
    uploadDate = '2025-04-04T00:00:00Z',
}: {
    id: string;
    title?: string;
    description?: string;
    uploadDate?: string;
}) => {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        name: title,
        description,
        thumbnailUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
        uploadDate,
        contentUrl: `https://www.youtube.com/watch?v=${id}`,
        embedUrl: `https://www.youtube.com/embed/${id}`,
    };

    return (
        <script type="application/ld+json" id="youtubeSchemaScript">
        {JSON.stringify(jsonLd)}
        </script>
    );
};

export default YouTubeStructuredData;
